export const SEARCH_HINT_LABEL_NAME = 'имя';
export const SEARCH_HINT_LABEL_METRO = 'метро';
export const SEARCH_HINT_LABEL_DISTRICT = 'район';
export const SEARCH_HINT_LABEL_SPECIALIZATION = 'специализация';
export const SEARCH_HINT_LABEL_SERVICE = 'услуга';
export const SEARCH_HINT_LABEL_CITY = 'город';
export const SEARCH_HINT_LABEL_SUGGESTIONS = 'подсказки';
export const SEARCH_HINT_LABEL_ORGANIZATION = 'организация';
